import React from 'react';
import Authenticated from "../../components/Authenticated";
import Typography from "@mui/material/Typography";
import moment from "moment-timezone";
import EventTable from "../../components/Event/EventTable";
import SeriesSelector from "../../components/Event/SeriesSelector";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {Add} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import AddEvent from "./AddEvent";
import EventSetup from "../Event/EventSetup";
import {useDispatch, useSelector} from "react-redux";
import {setEvent} from "../../slices/sessionSlice";


export const getEventDatesString = (comp)=> {
    const firstDate = comp.firstRacingDate ? comp.firstRacingDate : comp.firstDate
    if (moment(firstDate).year() === moment(comp.lastDate).year()) {
        if (moment(firstDate).month() === moment(comp.lastDate).month()) {
            return `${moment(firstDate).format('D')} - ${moment(comp.lastDate).format('D MMMM yyyy')}`
        }
        else {
            return `${moment(firstDate).format('D MMMM')} - ${moment(comp.lastDate).format('D MMMM yyyy')}`
        }
    }
    else {
        return `${moment(firstDate).format('D MMMM yyyy')} - ${moment(comp.lastDate).format('D MMMM yyyy')}`
    }
}


const Calendar = () => {
    const session = useSelector(state => state.session)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [series, setSeries] = React.useState()
    const [mode, setMode] = React.useState('calendar')
    const [selectedEventId, setSelectedEventId] = React.useState()

    const handleSeriesChange = (s) => {
        setSeries(s)
    }

    const handleAdd = () => {
        setMode('addEvents')
    }


    const handleClose = () =>{
        setMode('calendar')
    }

    const onEventEdit =(comp) => {
        setSelectedEventId(comp.id)
        setMode('viewSetup')
        dispatch(setEvent(comp))
    }

    const onEventSelected =(comp) => {
        dispatch(setEvent(comp))
        navigate('/event')
    }

    const nonManagerView = () => {
        return (
            <Container maxWidth={'lg'}>
                <Box sx={{
                    display:'flex',
                    alignItems:'center',
                    mt:'2em',
                    mb:'1em',
                }}>
                    <Typography variant={'h2'} flexGrow={1} sx={{textAlign:'left'}}>Event calendar</Typography>
                    <SeriesSelector onChange={handleSeriesChange}/>
                </Box>
                <EventTable series={series} onEventSelected={onEventSelected}/>
            </Container>
        )
    }

    return (
        <Authenticated scopes={['SERVICE_SGP_ADMIN']} notAuthorizedView={nonManagerView()}>
            { mode === 'calendar' &&
            <Container maxWidth={'lg'}>
                <Box sx={{
                    display:'flex',
                    alignItems:'center',
                    mt:'2em',
                    mb:'1em',
                }}>
                    <Typography variant={'h2'} flexGrow={1} sx={{textAlign:'left'}}>Event calendar</Typography>
                    <SeriesSelector onChange={handleSeriesChange}/>
                    <Box ml={1}><IconButton onClick={handleAdd}><Add/></IconButton></Box>
                </Box>

                <EventTable series={series} onEventEdit={onEventEdit} onEventSelected={onEventSelected} isManager={true}/>
            </Container>
            }
            { mode ==='addEvents' &&
                <AddEvent onClose={handleClose}/>
            }
            { mode === 'viewSetup' &&
                <Container maxWidth={'lg'}>
                    <EventSetup eventId={selectedEventId} onClose={handleClose} withHeader={true}/>
                </Container>
            }
        </Authenticated>
    );
};

export default Calendar;